export default "__VITE_ASSET__34e7e4d1__"